import {Dropdown, Menu, Modal} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProfileView } from "../header/style";
import { FindMenus } from "./menus";
import { MenuView } from "./style";
import {ExclamationCircleOutlined} from "@ant-design/icons";


const ProfileMenu = ({ user, onLogout }) => {
  const { email, name, photo } = user?.user?.user_data || {};
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showLogoutModal = () => setIsModalVisible(true);
  const handleConfirmation = () => {
    setIsModalVisible(false);
    onLogout();
  };
  const handleCancel = () => setIsModalVisible(false);

  return (
      <ProfileView
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-225px"
          data-kt-menu="true"
      >
        {/* Profile Section */}
        <div className="menu-item px-3">
          <div className="menu-content d-flex align-items-center px-3">
            <div className="symbol symbol-40px symbol-circle me-5">
              <img alt="Profile" src={photo || "../assets/media/avatars/blank.png"} />
            </div>
            <div className="d-flex flex-column" style={{wordBreak: "break-word"}}>
              <div className="fw-bold d-flex align-items-center fs-5">{name}</div>
              <a href="#" className="fw-semibold text-muted text-hover-danger fs-7">
                {email}
              </a>
            </div>
          </div>
        </div>

        <div className="separator my-2" />

        {/* Menu Items */}
        <div className="menu-item px-5">
          <Link to="/settings/myprofile" className="menu-link px-5">
            My Profile
          </Link>
        </div>
        <div className="menu-item px-5 my-0">
          <Link to="settings/marketplace-credentials" className="menu-link px-5">
            Account Settings
          </Link>
        </div>
        <div className="menu-item px-5">
          <div
              onClick={showLogoutModal}
              className="menu-link bg-danger text-light rounded-5 px-5 justify-content-center"
              style={{ borderRadius: "40px", cursor: "pointer" }}
          >
            Sign Out
          </div>
        </div>
        <Modal
            title={
              <div className="d-flex align-items-center gap-2">
                <ExclamationCircleOutlined style={{ color: "#f45b68", fontSize: 24 }} />
                <span className="fw-semibold fs-4 text-danger">Confirm Logout</span>
              </div>
            }
            open={isModalVisible}
            onOk={handleConfirmation}
            onCancel={handleCancel}
            okText="Yes, Logout"
            cancelText="Cancel"
            centered
            className="custom-logout-modal"
        >
          <p className="fs-5 text-muted mb-0">
            Are you sure you want to log out of your session?
          </p>
        </Modal>
      </ProfileView>
  );
};

export default function Sidebar({
                                  collapsed,
                                  user,
                                  type,
                                  toggleSidebar,
                                  location,
                                  handleLogout
                                }) {
  const [current, setCurrent] = useState(location?.pathname?.replace("/", ""));
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    const path = location?.pathname || "";
    setCurrent(path.replace("/", ""));
    const pathParts = path.split("/").filter(Boolean);
    if (pathParts.length > 1) {
      setOpenKeys([pathParts.slice(0, -1).join("/")]);
    } else {
      setOpenKeys([]);
    }
  }, [location]);

  const menuItems = FindMenus(type);
  const { email, name, photo } = user?.user?.user_data || {};

  return (
      <div
          id="kt_app_sidebar"
          collapsible
          collapsed={collapsed}
          className="app-sidebar flex-column"
          data-kt-drawer="true"
          data-kt-drawer-name="app-sidebar"
          data-kt-drawer-activate="{default: true, lg: false}"
          data-kt-drawer-overlay="true"
          data-kt-drawer-width="250px"
          data-kt-drawer-direction="start"
          data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
      >
        {/* Sidebar Header */}
        <div
            className="app-sidebar-header d-flex flex-stack d-none d-lg-flex pt-8 pb-2"
            id="kt_app_sidebar_header"
        >
          <a href="index.html" className="app-sidebar-logo d-flex">
            <img
                src="/assets/media/sellerView-favicon.png"
                alt="Logo"
                className="h-40px" // adjust height/width as needed
                style={{ height: "25px", width: "25px", objectFit: "contain" }}
            />
          </a>

          <div
              id="kt_app_sidebar_toggle"
              onClick={toggleSidebar}
              className="app-sidebar-toggle btn btn-sm btn-icon bg-light border border-gray-300 btn-color-gray-700 btn-active-color-primary d-none d-lg-flex rotate w-35px h-35px w-md-30px h-md-30px"
              data-kt-toggle="true"
              data-kt-toggle-state="active"
              data-kt-toggle-target="body"
              data-kt-toggle-name="app-sidebar-minimize"
              style={{ cursor: "pointer" }}
          >
            <i className="ki-outline ki-black-left-line rotate-180 fs-1 text-dark" />
          </div>
        </div>

        {/* Sidebar Navs */}
        <div className="app-sidebar-navs flex-column-fluid py-6" id="kt_app_sidebar_navs">
          <div
              id="kt_app_sidebar_navs_wrappers"
              className="app-sidebar-wrapper hover-scroll-y my-2"
              data-kt-scroll="true"
              data-kt-scroll-activate="true"
              data-kt-scroll-height="auto"
              data-kt-scroll-dependencies="#kt_app_sidebar_header"
              data-kt-scroll-wrappers="#kt_app_sidebar_navs"
              data-kt-scroll-offset="5px"
          >
            {/* User Info Dropdown */}
            <div className="app-sidebar-menu-secondary menu menu-rounded menu-column mb-0">
              <div className="card border-0 pc-user-card mb-7">
                <div className="card-body p-0">
                  <div
                      className="menu-content d-flex flex-wrap flex-row align-items-center px-0"
                      id="kt_header_user_menu_toggle"
                  >
                    <Dropdown trigger={["click"]} overlay={<ProfileMenu user={user} onLogout={handleLogout} />} placement="bottomRight">
                      <div
                          className="log-out cursor-pointer"
                          data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                          data-kt-menu-attach="parent"
                          data-kt-menu-placement="bottom-end"
                          style={{ cursor: "pointer" }}
                      >
                        <i className="ki-outline ki-dots-horizontal fs-1 text-dark" />
                      </div>
                    </Dropdown>

                    <div className="symbol symbol-circle symbol-50px me-5">
                      <img alt="Logo" src={photo || "../assets/media/avatars/blank.png"} />
                    </div>

                    <div className="d-flex flex-column mt-0">
                      <div className="fw-bold d-flex align-items-center fs-4">{name}</div>
                      <a href="#" className="fw-semibold text-muted text-hover-danger fs-7">
                        {email}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="separator border-gray-300 mb-7 mx-10" />

            {/* Sidebar Menu */}
            <div
                id="#kt_app_sidebar_menu"
                data-kt-menu="true"
                data-kt-menu-expand="false"
                className="app-sidebar-menu-primary menu menu-column menu-rounded menu-sub-indention menu-state-bullet-primary"
            >
              <MenuView>
                <Menu
                    className="mt-5"
                    selectedKeys={[current]}
                    openKeys={[...new Set([...openKeys, "settings"])]}
                    onOpenChange={(keys) => setOpenKeys([...new Set([...keys, "settings"])])}
                    onClick={(e) => setCurrent(e.key)}
                    theme="light"
                    mode="inline"
                    items={menuItems}
                    style={{
                      position: "relative",
                      right: "0px",
                      top: collapsed ? "20px" : "0px",
                    }}
                />
              </MenuView>
            </div>
          </div>
        </div>
      </div>
  );
}